import { conf } from '../config/config';

const contactEndpoint = `${conf.endpoint.replace(/\/$/, '')}/api/contact`;

export async function submitContact(payload) {
    const response = await fetch(contactEndpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(result.error?.message || 'We could not send your message. Please try again.');
    }

    return result.data;
}
